<style>
.box {
    padding: 15px;
    border-bottom: 1px solid #eee;
    background-color: white;
    cursor: pointer;
    word-wrap: break-word;
    user-select: none;
}

.box:hover {
    background-color: #ebebf3;
}

.title {
    font-size: 12px;
    font-weight: bold;
}

.prelude {
    font-size: 12px;
    color: grey;
    line-height: 2.0em;
}

.badge {
    padding: 1px;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 15px;
    margin-left: 5px;
    margin-right: 5px;
    background-color: rgb(123, 123, 123);
    color: white;
}

.item-area-name {
    color: grey;
    font-size: 12px;
    font-weight: normal;
}

.controls {
    margin-top: 10px;
    width: 100%;
}

.rich-content-holder {
    font-size: 14px;
}

.type-badge {
    padding: 3px;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 15px;
    color: white;
    font-size: 12px;
    display: inline-block;
    line-height: 1em;
    margin-right: 5px;
}

.rich-content-holder {
    margin-top: 5px;
}

.control {
    color: grey;
    border:1px solid rgb(223, 223, 223);
    border-radius: 15px;
    font-size: 12px;
    display: inline-flex;
    flex-direction: row;
    line-height: 1em;
    overflow: hidden;
}

.control-number {
    padding: 3px;
    padding-left: 5px;
    border-right: 1px solid rgb(223, 223, 223);
}

.control-button {
    padding: 3px;
    padding-right: 5px;
}

.control-button:hover {
    background-color: rgb(70, 70, 70) !important;
    border-color: rgb(70, 70, 70);
    color: white;
}

.likes {
    padding: 3px;
    padding-left: 5px;
    border: 1px solid rgb(223, 223, 223);
    border-right: none;
    color: grey;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    font-size: 12px;
    display: inline;
}

.feed-button {
    border:1px solid rgb(223, 223, 223);
    color: grey;
    background: none;
    font-size: 12px;
    padding: 3px;
    padding-left: 5px;
    padding-right: 5px;
    height: 22px;
}

.feed-button:hover {
    background-color: grey;
    color: white;
    border-color: grey;
}

.like-button {
    margin: 0px;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
}

/* Municipal Items */
.poll-option {
    font-size: 12px;
    padding: 1px;
    padding-left: 8px;
    background-color: whitesmoke;
    border:1px solid rgb(223, 223, 223);
    border-radius: 15px;
    cursor: pointer;
    width: 50%;
    margin: 8px;
    margin-left: 0px;
}

.add-comment-holder {
    padding-left: 10px;
    padding-right: 10px;
}

@media (max-width:972px) {
    .box {
        padding-left: 5px;
        padding-right: 5px;
    }
    .box:focus {
        background-color: red;
    }


    .box:hover {
        background-color: white;
    }

    .add-comment-holder {
        padding: 5px;
    }
}
</style>


<script>
import {onMount} from 'svelte'
import * as Common from '../Common.js'
import {push} from '../pt-router/Router.svelte'
import PollDisplay from '../PollDisplay.svelte'
import AddCommentWidget from '../AddCommentWidget.svelte'
import ShareItemWidget from '../Sharing/ShareItemWidget.svelte'

export let displayAreaLabels
export let includeNames
export let item
export let setScrollState /* function (String elem_id) */

let pollOptions = null

onMount(async () => {
    if(item.type === Common.ITEMTYPE_POLL) {
        Common.getData('item/poll/'+item.id)
        .then(data => {
            if(!data) {
                alert("Error Retrieving Poll")
                return
            }

            pollOptions = data
        })
    }
})

function stop(e) {
    e.stopPropagation()
}

let widget = 'none'

function setItemAsScrollState(id) {
    setScrollState("item_"+id)
}

function goToItem(e, id) {
    setItemAsScrollState(id)

    e.currentTarget.style.backgroundColor = 'rgb(220, 220, 230)'
    push('/item/' + id)
}

function likeItem() {
    Common.trylikeItem(item.id, push, () => item.likes+=1)
}

function openCommentWidget() {
    if(!Common.currentUserValue) {
        Common.CreateNotification({body: "You must login to contribute!"}, 1000)
        push('/login')
    }
    widget = 'comment'
}

function openShareWidget() {
    widget = 'share'
}

function hideWidget() {
    widget = 'none'
}

function addComment(newComment) {
    Common.addCommentToItem(item, newComment, () => item.commentcount+=1)
    hideWidget()
}

</script>

<div style={"border-left: 3px solid " + Common.getItemTypeColorString(item.type)} id={"item_"+item.id} class="box item" on:click={(e) => goToItem(e, item.id)}>
    <div class="prelude">
        <div class="type-badge" style={"background-color:" + Common.getItemTypeColorString(item.type) + ";"}>
            {Common.getItemTypeString(item.type)}
        </div>
        <a class="title">{item.title}</a>
        {#if displayAreaLabels}
            <span class="item-area-name">in  <a href={"#/area/" + item.area_id} on:click={(e) => {setItemAsScrollState(item.id),stop(e)}}>{item.area_name}</a></span>
        {/if}
        {#if includeNames}
            by
            <div style="display: inline-block;">
                {#if !item.user_name}
                    <strong>Deleted User</strong>
                {:else}
                    <a style={item.user_area_name ? "color: rgb(123, 123, 123); font-weight: bold" : ""} href={"#/user/" + item.user_id} on:click={(e) => {setItemAsScrollState(item.id),stop(e)}}>{item.user_name}</a>
                    {#if item.user_special}<span class="badge">{Common.getSpecialStr(item.user_special)}</span>{/if}
                    {#if item.user_area_name}<span class="badge">{item.user_area_name} Area Official</span>{/if}
                {/if}
            </div>
        {/if}
    </div>
        <div class="rich-content-holder">
            {#if pollOptions}
                {#each pollOptions as option}
                    <div class="poll-option">{option.text}</div>
                {/each}
            {:else}
                {@html item.screened ? Common.sanitizeContent(item.content) : Common.RemoveImagesIfNeeded(Common.sanitizeContent(item.content))}{#if item.content.length == 300 }...{/if}
            {/if}
        </div>
    <div class="controls">
        <div class="control">
            <div class="control-number">{item.likes}</div>
            <div class="control-button" on:click={(e) => {stop(e),likeItem()}}>Like</div>
        </div>
        <div class="control">
            <div class="control-number">{item.commentcount}</div>
            <div class="control-button" on:click={(e) => {openCommentWidget(),stop(e)}}>Comment</div>
        </div>
        {#if pollOptions != null}
            <div class="control">
                <div class="control-number">{pollOptions.reduce((tot,n) => tot + n.votes, 0)}</div>
                <div class="control-button">Vote</div>
            </div>
        {/if}
    </div>
</div>
{#if widget === 'comment'}
    <div class="add-comment-holder">
        <AddCommentWidget {addComment} {hideWidget}></AddCommentWidget>
    </div>
{:else if widget === 'share'}
    <ShareItemWidget {item} {hideWidget}></ShareItemWidget>
{/if}